import React, { useEffect, useState } from "react";
import { Collapse, Dropdown } from "react-bootstrap";
import dayjs from "dayjs";
import { BiComment, BiCommentCheck, BiExpandAlt, BiTimer } from "react-icons/bi";
import { BsSortUp } from "react-icons/bs";
import { CgNotes } from "react-icons/cg";
import { CiEdit } from "react-icons/ci";
import { MdFilterList, MdOutlineDeleteOutline } from "react-icons/md";
import InboxChats from "../../InboxManagement/InboxChats";
import { FaXmark } from "react-icons/fa6";
import { inboxServices } from "../../../APIServices/SitePilotManagement/inboxServices";
import Swal from "sweetalert2";
import UpdateNotes from "./UpdateNotes";
import UseToggle from "../../../Hooks/UseToggle";
import { noteServices } from "../../../APIServices/SitePilotManagement/noteServices";
import { VscHistory } from "react-icons/vsc";
import TimelineNoteHistory from "./TimelineNoteHistory";

const ContactTimelines = ({ contactId, inboxId, currentUserData }) => {
  const toggles = UseToggle();
  const [expandedId, setExpandedId] = useState(null);

  const [timeline, setTimeline] = useState([]);
  const [loader, setLoader] = useState(false);
  const [inboxData, setInboxData] = useState("");
  const [timelineData, setTimelineData] = useState("");
  const [noteData, setNoteData] = useState("");
  const [action, setAction] = useState("");
  const [messages, setMessages] = useState([]);
  const [inboxloader, setInboxLoader] = useState(false);

  const getTimelineBasedonContact = async () => {
    setLoader(true);
    const data = await inboxServices.getTimelineBasedonContact(currentUserData?.loginPropertyId, contactId, inboxId || null);
    setTimeline(buildConversationTimeline(data?.data || []));
    setLoader(false);
  };

  const getSingleNote = async (noteId) => {
    toggles.setToggle()
    const data = await noteServices.getSingleNote(contactId, noteId);
    setNoteData(data?.data || "");
  };

  const deleteTimeline = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this timeline?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {}
        userData.id = id
        let data = await inboxServices.deleteTimeline(userData)
        if (data?.statusCode === 200) {
          getTimelineBasedonContact();
        }
      }
    });
  };

  const getSingleInbox = async (inboxId, sessionId) => {
    setInboxLoader(true)
    let data = await inboxServices.getSingleInbox(inboxId, sessionId);
    const inbox = data?.data || {};
    const msgs = inbox?.messages || [];
    setInboxData(inbox);
    setMessages(msgs);
    setInboxLoader(false)
  };

  const buildConversationTimeline = (timeline) => {
    return timeline.map((item) => {
      const date = dayjs(item.timelineDT);
      return item.type === "note" ? {
        id: item._id,
        dateGroup: date.format("DD MMM YYYY"),
        time: date.format("hh:mm A"),
        contactId: item?.contactId,
        inboxId: item.inboxId,
        uniqueId: item?.uniqueId,
        preview: item?.value,
        previousValue: item?.previousValue,
        currentValue: item?.currentValue,
        activityByName: item?.activityByName,
        type: item.type,
        action: item.action,
      } : item.type === "webSession" ? {
        id: item._id,
        type: item.type,
        uniqueId: item.uniqueId,
        inboxId: item.inboxId,
        contactId: item.contactId,
        sessionStatus: item.sessionStatus,
        dateGroup: date.format("DD MMM YYYY"),
        time: date.format("hh:mm A"),
        preview: item.value,
      } : {
        id: item._id,
        type: item.type,
        uniqueId: item.uniqueId,
        inboxId: item.inboxId,
        contactId: item.contactId,
        sessionStatus: item.sessionStatus,
        chatStatus: item.chatStatus,
        answered: item.answered,
        dateGroup: date.format("DD MMM YYYY"),
        time: date.format("hh:mm A"),
        preview: item.value,
      };
    });
  };

  useEffect(() => {
    if (contactId) {
      getTimelineBasedonContact();
    }
  }, [inboxId, contactId]);
  return (
    <>
      <div className="preview-block">
        <div className="timeline-wrapper">
          <div className="timeline-header">
            <div className="preview-switcher p-0" style={{ zIndex: 1 }}>
              <Dropdown align="end">
                <Dropdown.Toggle className="profile-btn px-2 border">
                  <MdFilterList size={12} />
                  Filter
                </Dropdown.Toggle>
                <Dropdown.Menu align="end" className="profile-menu shadow-sm">
                  <Dropdown.Item className="menu-item">Activity</Dropdown.Item>
                  <Dropdown.Item className="menu-item">Agent</Dropdown.Item>
                  <Dropdown.Item className="menu-item">Tag</Dropdown.Item>
                  <Dropdown.Item className="menu-item">Created</Dropdown.Item>
                  <Dropdown.Item className="menu-item">Updated</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>

            <div className="preview-switcher p-0" style={{ zIndex: 1 }}>
              <button className="timeline-btn border px-2">
                <span>Created on</span>
                <BsSortUp size={12} />
              </button>
            </div>
          </div>

          {timeline.map((item, index) => {
            const showDate =
              index === 0 ||
              timeline[index - 1].dateGroup !== item.dateGroup;
            const isExpanded = expandedId === `${item.contactId}${item?.inboxId || "INBOX"}${item.uniqueId}`;
            return (
              <React.Fragment key={index}>
                {showDate && (
                  <div className="timeline-date">{item.dateGroup}</div>
                )}
                {item.type === "note" ?
                  <div className="timeline-item">
                    <div
                      className={`timeline-icon bg-primary-subtle text-primary`}>
                      <CgNotes />
                    </div>
                    <div className="timeline-card">
                      <div className="timeline-card-header">
                        <strong>Note</strong>
                        <span className="muted text-capitalize">{item.action} By: {item?.activityByName}</span>
                        <time>{item.time}</time>
                      </div>
                      {(noteData?.noteId === item?.uniqueId && action === item?.id) ?
                        <UpdateNotes
                          setAction={setAction}
                          title={`Update Note`}
                          getNoteList={getTimelineBasedonContact}
                          contactId={contactId}
                          noteData={noteData}
                          setNoteData={setNoteData}
                        />
                        :
                        <>
                          <p className="timeline-text">
                            {item?.preview?.split("\n").map((l, i) => (
                              <div key={i}>{l}</div>
                            ))}
                          </p>
                          {item.action !== "deleted" &&
                            <button
                              className="timeline-action"
                              title="Edit Note"
                              style={{ right: 70 }}
                              onClick={() => { getSingleNote(item?.uniqueId); setAction(item?.id) }}
                            >
                              <CiEdit />
                            </button>
                          }
                          <button
                            className="timeline-action"
                            title="Changelogs"
                            style={{ right: 40 }}
                            onClick={() => { setTimelineData(item); toggles.setToggle1() }}
                          >
                            <VscHistory />
                          </button>
                          <button
                            onClick={() => deleteTimeline(item?.id)}
                            className="timeline-action text-danger"
                            title="Delete Note"
                          >
                            <MdOutlineDeleteOutline />
                          </button>
                        </>
                      }
                    </div>
                  </div>
                  :
                  <>
                    {item?.type === "webSession" ?
                      <div className="timeline-item">
                        <div
                          className={`timeline-icon bg-primary-subtle text-primary`}>
                          <BiTimer />
                        </div>
                        <div className="timeline-card">
                          <div className="timeline-card-header">
                            <strong>Web Session</strong>
                            <span className="muted text-capitalize">{item.sessionStatus}</span>
                            <time>{item.time}</time>
                          </div>
                          <p className="timeline-text">
                            {item?.preview?.split("\n").map((l, i) => (
                              <div key={i}>{l}</div>
                            ))}
                          </p>
                          <button onClick={() => deleteTimeline(item?.id)} className="timeline-action text-danger" title="Delete">
                            <MdOutlineDeleteOutline />
                          </button>
                        </div>
                      </div>
                      :
                      <div className="timeline-item">
                        <div title={(item?.type === "liveChat" || item?.type === "ticket") ? `Chat Status: ${item?.chatStatus === "close" ? "Closed" : item?.chatStatus === "open" ? "Open" : "Browsing"}\nAnswered Status: ${item?.answeredStatus ? "Answered" : "Missed"}` : ""}
                          className={`timeline-icon 
                  ${((item?.type === "liveChat" || item?.type === "ticket") && item?.preview) ? (item?.chatStatus === "browsing" ?
                              "bg-warning-subtle text-warning" :
                              item?.chatStatus === "open" ?
                                "bg-danger-subtle text-danger" :
                                "bg-success-subtle text-success") : ""}`}>
                          {!item?.answeredStatus ?
                            <BiComment />
                            :
                            <BiCommentCheck />
                          }
                        </div>
                        <Collapse in={isExpanded}>
                          <div className="w-100">
                            <InboxChats
                              setExpandedId={setExpandedId}
                              category={inboxData?.type}
                              inboxData={inboxData}
                              currentUserData={currentUserData}
                              getSingleInbox={getSingleInbox}
                              getInboxList={() => { }}
                              setSessionId={() => { }}
                              sessionId={item?.uniqueId}
                              type="quickChat"
                              messages={messages || inboxData?.messages || []}
                              setMessages={setMessages}
                            />
                          </div>
                        </Collapse>
                        {!isExpanded && (
                          <div className="timeline-card">
                            <div className="timeline-card-header">
                              <strong>{item.type === "liveChat" ? "Chat Session" : "Ticket Session"}</strong>
                              <span className="muted text-capitalize">{item.sessionStatus}</span>
                              <time>{item.time}</time>
                            </div>
                            <p className="timeline-text">
                              {item?.preview?.split("\n").map((l, i) => (
                                <div key={i}>{l}</div>
                              ))}
                            </p>
                            <button
                              className="timeline-action"
                              title={isExpanded ? "Close" : "Expand"}
                              style={{ right: 40 }}
                              onClick={() => {
                                getSingleInbox(item?.inboxId, item?.uniqueId)
                                setExpandedId((prev) => (prev === `${item.contactId}${item?.inboxId || "INBOX"}${item.uniqueId}` ? null : `${item.contactId}${item?.inboxId || "INBOX"}${item.uniqueId}`))
                              }}
                            >
                              {isExpanded ? <FaXmark /> : <BiExpandAlt />}
                            </button>

                            <button onClick={() => deleteTimeline(item?.id)} className="timeline-action text-danger" title="Delete">
                              <MdOutlineDeleteOutline />
                            </button>
                          </div>
                        )}
                      </div>
                    }
                  </>
                }
              </React.Fragment>
            );
          })}
        </div>
      </div>
      <TimelineNoteHistory
        show={!toggles.toggle1}
        hide={toggles.setToggle1}
        title={"Changelogs"}
        contactId={timelineData?.contactId}
        inboxId={timelineData?.inboxId}
        uniqueId={timelineData?.uniqueId}
        propertyId={currentUserData?.loginPropertyId}
      />
    </>
  );
};

export default ContactTimelines;
